import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { string } from "prop-types";

import DfpAd from "../../dfp-ad";
import { CloseIcon } from "../../basic/icons/close-icon";

import "./anchorAd.m.css";

const BottomAnchorAd = ({ pageType }) => {
  if (pageType === "not-found") return null;

  const [closeAd, setCloseAd] = useState(true);
  const [isScroll, setIsScroll] = useState(false);
  const [adShow, setAdShow] = useState(false);

  const [showAnchorAds, setShowAnchorAds] = useState(false);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const isScrollAxis = scrollY > 200;
      if (global.deviceWidth > 876 && scrollY >= 400) {
        setShowAnchorAds(true);
      } else if (global.deviceWidth < 876 && scrollY >= 300) {
        setShowAnchorAds(true);
      }
      if (isScrollAxis !== isScroll) {
        setIsScroll(true);
        setAdShow(true);
      }
    });
    return () => {
      setCloseAd(true);
      setIsScroll(true);
      setAdShow(false);
    };
  }, []);

  const scrollUpAd = { bottom: isScroll || adShow ? 0 : "-138px" };

  const closeAdBlock = () => {
    setCloseAd(false);
  };

  const adType = `Haal_Fashion_${pageType === "home-page" ? "HP" : "News"}_Anchor`;

  return (
    <>
      {showAnchorAds && closeAd && (
        <div
          className="ad-bottom-container"
          styleName={`ad-bottom ${showAnchorAds && closeAd ? "show-ad" : ""}`}
          style={scrollUpAd}
        >
          <div styleName="ad-bottom-wrapper">
            <div title="close" styleName="anchor-close ad-close" onClick={() => closeAdBlock()}>
              <CloseIcon color="#000" />
            </div>
            <div styleName="ad-wrapper">
              <DfpAd adtype={adType} slotId={adType} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

BottomAnchorAd.propTypes = {
  pageType: string,
};

const mapStateToProps = (state) => ({
  pageType: state.qt.pageType,
});

export default connect(mapStateToProps, null)(BottomAnchorAd);
